import React, {FunctionComponent} from 'react';
import {_ReactPixi} from '@inlet/react-pixi';
import {Rectangle} from 'pixi.js';
import {ButtonCustom, ButtonCustomIdle, ButtonCustomHover, ButtonCustomPressed, CoreSprite} from '@gongxigames/framework/core/fragments/react';

export type ArrowButtonProps = Omit<_ReactPixi.IContainer, 'position' | 'scale'> & {
    press: null | (() => void);
    position?: [x: number, y: number];
    flip?: boolean;
};

const NEXT_WIDTH = 134;
const NEXT_HEIGHT = 150;

export const ArrowButton: FunctionComponent<ArrowButtonProps> = (props) => {
    const y = (props.position?.[1] || 0) - NEXT_HEIGHT / 2;
    let x = (props.position?.[0] || 0) - NEXT_WIDTH / 2;
    const hitArea = new Rectangle(props.flip ? -NEXT_WIDTH : 0 , 0, NEXT_WIDTH, NEXT_HEIGHT);
    const scaleX = props.flip ? -1 : 1;
    const scale: [number, number] = [scaleX, 1];

    if (props.flip) {
        x += NEXT_WIDTH;
    }

    return (
        <ButtonCustom
            {...props}
            hitArea={hitArea}
            position={[x, y]}
        >
            <ButtonCustomIdle>
                <CoreSprite src='preloader_next_button_normal' scale={scale}/>
            </ButtonCustomIdle>
            <ButtonCustomHover>
                <CoreSprite src='preloader_next_button_focused' scale={scale}/>
            </ButtonCustomHover>
            <ButtonCustomPressed>
                <CoreSprite src='preloader_next_button_pressed' scale={scale}/>
            </ButtonCustomPressed>
        </ButtonCustom>
    );
};
